var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbTextInput',{attrs:{"name":_vm.$t('shippingRulesPage.tips.defineFreightValueToBe'),"type":"money","decimals":2},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }